import { CmStreamingFormat } from '@svta/cml-cta'

/**
 * Common Media Client Data Streaming Format
 *
 *
 * @enum
 *
 * @beta
 */
export const CmcdStreamingFormat = CmStreamingFormat as typeof CmStreamingFormat

/**
 * @beta
 */
export type CmcdStreamingFormat = CmStreamingFormat;
